function getElemento(lista, item) {
    var elemento = lista.filter((dato) => dato.ID_COMUNICADO == item);
    return elemento[0];
}
function getRespuestasSeparadas(respuestas) {
    var lista = respuestas.filter((item) => item.TIPO == 'VIS');
    var resp = respuestas.filter((item) => item.TIPO == 'RES');
    return { 'vistas': lista, 'respuestas': resp }
}
function formatoFecha(fecha) {
    let date = new Date(Date.parse(fecha));
    return `${date.getDate()}/${date.toLocaleString('default', { month: 'long' })}/${date.getFullYear()}`;
}
function formatoHora(fecha) {
    let date = new Date(Date.parse(fecha));
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; 
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return ` -- ${strTime}`
}
export default { getElemento, getRespuestasSeparadas, formatoFecha, formatoHora }